module.exports = __webpack_public_path__ + "static/media/estabelecimentos-proximos.7930c370.jpg";